import { render, staticRenderFns } from "./urgentPurchase.vue?vue&type=template&id=819bb108&scoped=true&"
import script from "./urgentPurchase.vue?vue&type=script&lang=js&"
export * from "./urgentPurchase.vue?vue&type=script&lang=js&"
import style0 from "./urgentPurchase.vue?vue&type=style&index=0&id=819bb108&lang=less&scoped=true&"
import style1 from "./urgentPurchase.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819bb108",
  null
  
)

component.options.__file = "urgentPurchase.vue"
export default component.exports